// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"ef4688e8","87":"dda8d2b3","356":"3e46b8af","472":"1b955c0f","526":"a1b5b5b3","848":"b4e675b2","998":"7c887e30"}[chunkId] + ".chunk.js";
};